








import Vue from 'vue'
import Component from "vue-class-component"
import { Prop } from "vue-property-decorator"
import Product from '@/models/product'
import { customer } from '@/store'

@Component
export default class ProductPrice extends Vue {
  @Prop() product!: Product

  get retailerPage() {
    return customer.retailerPage
  }

  get hasDiscount() {
    return !!this.product.oldPrice && !!this.product.price
      && this.product.oldPrice > this.product.price
  }

  get discountPercent() {
    const oldPrice = this.product.oldPrice as number
    return Math.round((oldPrice - (this.product.price as number)) / oldPrice * 100)
  }
}
